import { QueryClientProvider } from "@tanstack/react-query";
import ReactDOM from "react-dom/client";
import App from "./App";
import { queryClient } from "./features/querClient";

import "./sentry.client.config";
import "./shared/i18n";

const mount = async (el: HTMLElement, basename: string) => {
  const root = ReactDOM.createRoot(el as HTMLElement);

  root.render(
    // @ts-ignore
    <QueryClientProvider client={queryClient}>
      <App basename={basename} />
    </QueryClientProvider>
  );
};

// If we are in development and in isolation,
// call mount immediately
// if (process.env.NODE_ENV === "development") {
const devRoot = document.getElementById("_today-meet-dev-root");
const baseRoute = window._env_?.VITE_BASE_SUB_ROUTE
  ? window._env_?.VITE_BASE_SUB_ROUTE
  : import.meta.env.VITE_BASE_SUB_ROUTE;

if (devRoot) {
  mount(devRoot, baseRoute);
}

// We are running through container
// and we should export the mount function
export { mount };
